import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useMemo } from 'react';

import { ReportConfigExpanded } from '../../types/ReportConfig';

export const useXeroAccrualManualJournalPopupIsAvailable = (
    company: selectors.types.ExpandedCompany,
    reportConfig: ReportConfigExpanded | null
) => {
    return useMemo(() => {
        const hasLicenseFeature = company.licenseFeatures.includes(domain.CompanyLicenseFeature.XeroAccrualReports);
        const hasBetaFeature = company.betaFeatures.includes(domain.CompanyBetaFeature.XeroAccrualsReport);

        const isAvailable = hasLicenseFeature || hasBetaFeature;

        return (
            (reportConfig?.reportCode === domain.ReportCode.XeroPurchaseOrderLine ||
                reportConfig?.reportCode === domain.ReportCode.XeroBillInvoiceLine) &&
            isAvailable
        );
    }, [company.licenseFeatures, company.betaFeatures, reportConfig?.reportCode]);
};
